<template>
  <div class="wrap">
    <div class="beijing">
      <div class="bg_left">
        <img class="login_img" src="/static/img/login/login_bg.png" alt />
      </div>
      <!-- 登录框 -->
      <div class="right">
        <div class="login_from">
          <img class="logo" src="/static/img/login/luyu_logo.png" alt />
          <div class="login_text">登 录</div>

          <el-input
            prefix-icon="el-icon-user"
            class="password"
            v-model="username"
            placeholder="请输入帐号"
            maxlength="11"
          ></el-input>

          <el-input
            prefix-icon="el-icon-lock"
            class="password"
            placeholder="请输入密码"
            v-model="password"
            show-password
            maxlength="25"
          ></el-input>

          <el-button
            type="primary"
            class="login_button"
            :loading="is_loading"
            @click="login"
            round
            >登录</el-button
          >
          <div class="bottom_bar">
            <el-link type="primary" @click="beian">
              <img class="guohui" src="/static/img/login/guohui.png" alt />
              京ICP备19005205号-5
            </el-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 底栏 -->
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      is_loading: false,
      username: "",
      password: "",
    };
  },
  created() {
    require("post", "/lufish_user/v1/lufish_inform/", {}).then((res) => {
      console.log(res);
      if (res.code == 0) {
        this.$alert(`<h2 >${res.data}</h2>`, "通知", {
          showClose: false,
          confirmButtonText: "知道了",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "message",
          callback: (action) => {
            console.log(action);
          },
        });
      }
    });
  },
  methods: {
    //登录
    login() {
      let obj = {};
      if (!this.username || !this.password) {
        this.$message.error("账号密码没有填哦");
        this.is_loading = false;
        return;
      }
      obj.username = this.username;
      obj.password = this.password;
      // obj.title = 1
      this.is_loading = true;
      require("post", "/lufish_user/v1/user_login/", obj).then((res) => {
        console.log(
          "登录",
          res,
          res.data.realname,
          res.data.token,
          res.data.auth_grade
        );
        if (!res.code) {
          console.log("登录", res);
          // require('post', 'lufish_sale/v1/high_seas_update/', {
          //   token: res.data.token
          // }).then(res=> {})
          this.$cookies.set("realname", res.data.realname);
          this.$cookies.set("token", res.data.token);
          this.$cookies.set("parent_agent_id", res.data.parent_agent_id);
          this.$cookies.set("staff_id", res.data.staff_id);
          this.$cookies.set("agent_id", res.data.agent_id);
          //权限存储
          let auth_grade = res.data.auth_grade;
          console.log(res.data);
          this.$cookies.set("auth_grade", auth_grade);
          this.$cookies.set("agent_company_name", res.data.agent_company_name); //判断是否是代理商  如果值为空为三门课别的为代理商
          this.$cookies.set("agent_position", res.data.agent_position); //判断是否是代理商  如果值为空为三门课别的为代理商
          this.$cookies.set("product_name", res.data.product_name); //判断是否是代理商  如果值为空为三门课别的为代理商
          this.$cookies.set(
            "agent_province_name",
            res.data.agent_province_name
          ); //判断是否是代理商  如果值为空为三门课别的为代理商
          this.$cookies.set("agent_username", res.data.agent_username || "");
          // 将默认导航选中状态写入缓存
          if (res.data.auth_grade == 100) {
            this.$cookies.set("across_nav_index", "1");
            this.$cookies.set("vertical_nav_index", "1-1");
            this.$cookies.set("agent_username", res.data.agent_username || "");
          } else if (res.data.auth_grade == 60) {
            this.$cookies.set("across_nav_index", "1");
            this.$cookies.set("vertical_nav_index", "1-1");
            this.$cookies.set("agent_username", res.data.agent_username || "");
            if (res.data.agent_company_name == "") {
              this.$cookies.set("across_nav_index", "2");
              this.$cookies.set("vertical_nav_index", "2-1");
              this.$cookies.set("auth_grade", "61");
            }
          } else if (res.data.auth_grade == 30) {
            this.$cookies.set("across_nav_index", "3");
            this.$cookies.set("vertical_nav_index", "3-1");
            if (res.data.agent_company_name == "") {
              this.$cookies.set("across_nav_index", "4");
              this.$cookies.set("vertical_nav_index", "4-1");
            }
          } else if (res.data.auth_grade == 50) {
            this.$cookies.set("across_nav_index", "6");
            this.$cookies.set("vertical_nav_index", "6-1");
          } else if (res.data.auth_grade == 80 || res.data.auth_grade == 90) {
            //代理商有首页数据保存 1和1-1
            this.$cookies.set("across_nav_index", "1");
            this.$cookies.set("vertical_nav_index", "1-1");
            //代理商没有首页数据3和3-1
            // this.$cookies.set("across_nav_index", "3");
            // this.$cookies.set("vertical_nav_index", "3-1");
          } else {
            this.$cookies.set("across_nav_index", "3");
            this.$cookies.set("vertical_nav_index", "3-1");
            if (res.data.agent_company_name == "") {
              this.$cookies.set("across_nav_index", "4");
              this.$cookies.set("vertical_nav_index", "4-2");
            }
          }
          sessionStorage.setItem("token", res.data.token);
          // 隐藏加载，跳转到首页
          this.is_loading = false;
          if (res.data.auth_grade == 100) {
            this.$router.push({ path: "/index" });
          } else if (res.data.auth_grade == 30) {
            this.$router.push({ path: "/team_data" });
          } else if (res.data.auth_grade == 80 || res.data.auth_grade == 90) {
            //代理商有首页数据跳到 /index
            this.$router.push({ path: "/index" });
            //代理商有首页数据跳到 /team_data
            // this.$router.push({ path: "/team_data" });
          } else if (res.data.auth_grade == 50) {
            this.$router.push({ path: "/organizational_structure" });
          } else if (
            res.data.auth_grade == 60 &&
            this.$cookies.get("agent_company_name") != null
          ) {
            this.$router.push({ path: "/index" });
          } else if (
            res.data.auth_grade == 60 &&
            this.$cookies.get("agent_company_name") == null
          ) {
            this.$router.push({ path: "/add_user" });
          } else {
            this.$router.push({ path: "/me_data" });
            if (res.data.agent_company_name != "") {
              this.$router.push({ path: "/prepaidCustomerBillOfLading" });
            }
          }
          // location.reload();
          this.$message({
            message: "登录成功，" + "欢迎回来" + res.data.realname,
            type: "success",
          });
        } else {
          this.$message.error("登录失败，请检查账号密码");
          this.is_loading = false;
        }
      });
    },

    // 跳转icp查询网站
    beian() {
      // window.location.href = 'http://beian.miit.gov.cn';
      window.open("http://beian.miit.gov.cn", "_blank"); // 新窗口打开外链接
    },
  },
};
</script>

<style scoped>
/* .el-input__prefix, .el-input__suffix {
    position: absolute;
    top: 10px;
    -webkit-transition: all .3s;
    height: 100%;
    color: #C0C4CC;
    text-align: center;
} */
.wrap {
  width: 100%;
  overflow: hidden;
  position: absolute;
  height: 100%;
}
.input-placeholder {
  font-size: 12px;
}

.beijing {
  width: 100%;
  overflow: hidden;
  position: absolute;
  height: 100%;
}
.bg_left {
  width: 40%;
  height: 100%;
  float: left;
  text-align: center;
  background: #f0f5fa;
}
.guohui {
  width: 26px;
  height: 29px;
  position: relative;
  top: 6px;
}
.right {
  float: right;
  width: 50%;
  position: relative;
  height: 100%;
}
.bottom_bar {
  /* background: red; */
  clear: both;
  width: 100%;
  line-height: 30px;
  text-align: center;
  margin-top: 50px;
}

.login_button {
  margin-top: 80px;
  width: 50%;
  height: 44px;
  font-size: 18px;
}

.password {
  margin-top: 30px;
  width: 50%;
  font-size: 14px;
}

.username {
  width: 50%;
  height: 80px;
  font-size: 14px;
}

.login_text {
  margin-top: 70px;
  margin-bottom: 70px;
  font-size: 30px;
  color: #333;
  font-weight: 600;
}

.logo {
  width: 286px;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  width: 100px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.bg-purple {
  background: #f0f5fa;
  height: 99vh;
  display: flex;
  padding-left: 150px;
}

.bg-purple-light {
  /* background: #c07d19; */
  height: 99vh;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.login_from {
  /* background: blue; */
  /* height: 800px; */
  /* float: right; */
  width: 60%;
  margin: auto;
  height: 610px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -305px;
  margin-left: -30%;
}

.login_img {
  /* background: red; */
  width: 100%;
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}

.bg {
  min-width: 1200px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue